import type { SessionManager } from './SessionManager.js'
import { BrowserSessionManager } from './BrowserSessionManager.js'
import { KioskSessionManager } from './KioskSessionManager.js'
import type { CommerceHttpAdapter } from '../client/CommerceHttpAdapter.js'
import type { CommerceContext } from '../client/CommerceContext.js'

/**
 * Instancie le SessionManager adapté au contexte d'exécution.
 *
 * Détection du mode kiosk : présence de "Altazion Device Shell" dans le User-Agent.
 * Dans ce cas, le browser embarqué gère entièrement les cookies de session.
 */
export class SessionManagerFactory {
  static create(http: CommerceHttpAdapter, context: CommerceContext): SessionManager {
    if (context.mode === 'kiosk') {
      return new KioskSessionManager()
    }
    return new BrowserSessionManager(http, context)
  }
}
